import { Globe, Lock } from 'lucide-react'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Visibility } from '@/types'

interface VisibilitySelectorProps {
  value: Visibility
  onChange: (value: Visibility) => void
  disabled?: boolean
  showLabel?: boolean
  size?: 'sm' | 'default'
}

export default function VisibilitySelector({
  value,
  onChange,
  disabled = false,
  showLabel = true,
  size = 'default',
}: VisibilitySelectorProps) {
  return (
    <div className="space-y-2">
      {showLabel && <Label className="text-sm">Visibility</Label>}
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger className={size === 'sm' ? 'h-8' : ''}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="PUBLIC">
            <div className="flex items-center gap-2">
              <Globe className="h-4 w-4 text-green-500" />
              <div>
                <div className="font-medium">Public</div>
                <div className="text-xs text-muted-foreground">
                  All team members can access
                </div>
              </div>
            </div>
          </SelectItem>
          <SelectItem value="PRIVATE">
            <div className="flex items-center gap-2">
              <Lock className="h-4 w-4 text-orange-500" />
              <div>
                <div className="font-medium">Private</div>
                <div className="text-xs text-muted-foreground">
                  Only invited members can access
                </div>
              </div>
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}

// Compact visibility badge for display
export function VisibilityBadge({ visibility }: { visibility: Visibility }) {
  if (visibility === 'PUBLIC') {
    return (
      <div className="flex items-center gap-1 text-xs text-green-600">
        <Globe className="h-3 w-3" />
        <span>Public</span>
      </div>
    )
  }
  return (
    <div className="flex items-center gap-1 text-xs text-orange-600">
      <Lock className="h-3 w-3" />
      <span>Private</span>
    </div>
  )
}

